import { isAxiosError } from 'axios';

import { toast } from '@/components/ui/use-toast';
import { api } from '@/lib/api-client';

import { MatchStatus } from '../types';

export async function fetchMatchStatus(
  matchId: string | undefined,
): Promise<MatchStatus> {
  try {
    if (!matchId) {
      throw new Error('Must pass a matchId');
    }
    return api.get(`/matches/${matchId}/status`);
  } catch (error: any) {
    if (isAxiosError(error)) {
      toast({
        variant: 'destructive',
        title: 'Error',
        description: error.response?.data,
      });
    }
    throw error;
  }
}
